import { render, staticRenderFns } from "./BaseShopPendingPolicies.vue?vue&type=template&id=0e8ee828&"
import script from "./BaseShopPendingPolicies.vue?vue&type=script&lang=js&"
export * from "./BaseShopPendingPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports